import { ButtonHeading } from 'components'
import useDocumentTitle from 'hooks/useDocumentTitle'
import React from 'react'
import { FaRegStar } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

const TripReports = () => {
  useDocumentTitle("Reports | T360");
  return (
    <>
      <ButtonHeading title="Reports"
      // onClick={{}} 
      // buttonTitle="Reports Sharing" 
      />

      <section className='__categories-container'>

        <div className='__content container-fluid'>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className='_section-categories'>
                <div className='__categories-titleBx'>
                  <div className='__category-title'>Quick Reports</div>
                </div>

                <div className='__categoriesOtr'>
                  <Link to='/report/profit_loss_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Profit and Loss Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/trip_detail_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Trip Detail Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/trip_revenue_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Trip Revenue Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/trip_profit_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Trip Profit Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/trip_report_summary' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Dispatch Trip Report </div>
                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/lr_detail_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> LR Detail Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                </div>
              </div>

              <div className='_section-categories'>
                <div className='__categories-titleBx'>
                  <div className='__category-title'>Reports</div>
                </div>

                <div className='__categoriesOtr'>
                  <Link to='/report/balance_sheet' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Balance Sheet</div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/horizontal_balance_sheet' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Horizontal Balance Sheet </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/profit_and_loss_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Profit and Loss </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/horizontal_profit_loss' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Horizontal Profit and Loss </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/trial_balance' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Trial Balance </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/general_ledger' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> General Ledger  </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/journal_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Journal Report  </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className='_section-categories'>
                <div className='__categories-titleBx'>
                  <div className='__category-title'> Vehicle Reports </div>
                </div>

                <div className='__categoriesOtr'>

                  <Link to='/report/own_vehicle_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Own Vehicle Profit Report</div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/vehicle_profit_report' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Vehicle Profit Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='/report/vehicled' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> All Vehicle Detailed Report </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              <div className='_section-categories'>
                <div className='__categories-titleBx'>
                  <div className='__category-title'> Sales </div>
                </div>

                <div className='__categoriesOtr'>
                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Sales Register</div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Sales by Customer </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              <div className='_section-categories'>
                <div className='__categories-titleBx'>
                  <div className='__category-title'> Receivables </div>
                </div>

                <div className='__categoriesOtr'>
                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Account Receivable Summary </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'> Customer Balances </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Aging Summary </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Invoice Details </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Aging Details </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Estimate Details </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Most Valuable Customers</div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Invoice Payments (Payments Method Wise) </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Invoice Payments Reminder </div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                  <Link to='' className='__categoriesReport'>
                    <div className='d-flex justify-content-between align-items-center me-2 cursor-pointer'>
                      <div className='d-flex'>Invoice Interest Calculator</div>

                      <div className='d-flex'>
                        <FaRegStar className='ms-2 hollow-star' />
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TripReports